import * as angular from "angular";

angular
  .module('bringoz.admin.expenses')
  .config(ExpensesConfig);

/* @ngInject */
function ExpensesConfig($stateProvider) {
  $stateProvider

    .state('expenses-view', {
      parent: 'bringoz.site',
      url: '/expenses?:categoryIds&:statuses&:agentIds&:accountIds&:from&:to&:query',
      params: {
        categoryIds: null,
        statuses: null,
        accountIds: null,
        from: null,
        to: null,
        query: null
      },
      controllerAs: 'vm',
      template: '<expenses-view enable-filter-by-agent="true" enable-filter-by-carrier="true" account-ids="vm.accountIds" agent-ids="vm.agentIds" category-ids="vm.categoryIds" statuses="vm.statuses"' +
        ' from="vm.from" to="vm.to" query="vm.query"></expenses-view>',
      controller: function (site, $stateParams,triBreadcrumbsService) {

        this.agentIds = $stateParams.agentIds;
        this.accountIds = $stateParams.accountIds;
        this.categoryIds = $stateParams.categoryIds;
        this.statuses = $stateParams.statuses;
        this.from = parseInt($stateParams.from);
        this.to =  parseInt($stateParams.to);
        this.query = $stateParams.query;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Expenses'});
        triBreadcrumbsService.addCrumb({name: "Finance"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })
}
